// Version info - auto-generated at build time via postbuild.js
// Check window.__BUILD_INFO__ for actual build details

export const VERSION = {
  get info() {
    return (window as any).__BUILD_INFO__ || {
      gitHash: 'dev',
      buildTime: new Date().toISOString()
    };
  }
};

// Log version on app start (visible in browser console)
setTimeout(() => {
  const info = VERSION.info;
  console.log(`%c Förvaltningen `, 'background: #3B82F6; color: white; font-weight: bold; padding: 4px 8px; border-radius: 4px;');
  console.log(`Git: ${info.gitHash} | Build: ${info.buildTime}`);
}, 100);
